import { Component, OnInit, TemplateRef, viewChild, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DynamictableComponent } from 'src/app/shared/dynamictable/dynamictable.component';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from "src/app/popup/popup.component";
import { formatDate } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ApprovalDashBoardService } from "src/app/services/approval-dashboard/approval-dashboard.service"
import Swal from 'sweetalert2';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { BillingAdjustmentDetails, InvoiceDetails } from 'src/app/Models/invoiceDetails';
import { AuthService } from 'src/app/services/auth/auth.service';
import { saveAs } from "file-saver";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup,FormsModule, Validators,ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatError } from '@angular/material/form-field';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MsalService } from '@azure/msal-angular';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { BillingAdjustmentStatusEnumDisplay, formatDateRange } from 'src/utilities';
import { MatDatepickerModule, MatDateRangeInput } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { BulkRequestService } from 'src/app/services/bulk-request/bulk-request.service';
import { DateRangeErrorStateMatcher } from 'src/app/approval-history/approval-history/approval-history.component';
import { BillingAdjustmentStatusEnum, dateRangeValidator, formatDateforBAT } from 'src/utilities';
import { SharedModule } from 'src/app/shared/shared.module';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { LegendComponent } from 'src/app/shared/legend/legend.component';
import { FilterDto} from "src/utilities";

@Component({
    selector: 'app-bulk-request-reports',
    imports: [FormsModule, MatDatepickerModule, MatDateRangeInput, MatSelectModule, MatError, MatNativeDateModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, DynamictableComponent, PopupComponent, MatProgressSpinnerModule, NgxSpinnerModule, MatTableModule, SharedModule, LegendComponent],
    templateUrl: './bulk-request-reports.component.html',
    styleUrl: './bulk-request-reports.component.scss'
})
export class BulkRequestReportsComponent  implements OnInit{


  selectedData: any;
  isGoodWillRequest: boolean = false;
  chooseDialogRef: any;
  detailData: any[] = [];
  isLoader: boolean = true;
  isDetailView = false;
  dateForm: FormGroup;
  matcher = new DateRangeErrorStateMatcher();
  startDateInvalid: boolean = false;
  endDateInvalid: boolean = false;
  filters: FilterDto[] = [];
  currentAppliedFilters: FilterDto[] = []; // Track filters used in current view
  totalCount: number=0;
  formValue:any
  pageSize: number=10;
  statusFilter: string = '';
  allRequestList: any[] = []; // holds all unfiltered data
    @ViewChild('detailsTemplate') detailsTemplate: TemplateRef<any>;
    requestReportSearch:any ={
    startDate:new Date(),
    endDate:new Date(),
    reportType: 1,
    statusType:0
  }
detailsModalRef: any;
miApprovalLegend: string ='MI Approval - Indicates requests that have been awaiting approval for more than 3 days.'
gbsApprovalLegend: string = 'GBS Approval - Indicates requests that have been awaiting approval for more than 5 days.';

  // ✅ Used for master table display
  readonly mainTableFieldMapping = [
    { label: 'Adj Req Id', propertyName: 'detailedAdjSubId' },
    { label: 'Requested Date', propertyName: 'adjRequestDate' },
    { label: 'Billing Site', propertyName: 'billingSite' },
    { label: '#MMS', propertyName: 'mms' },
    { label: 'Customer Name', propertyName: 'custName' },
    { label: 'Amount', propertyName: 'totalCorrectCharges' },
    {label:'Check Request',propertyName:'checkRequest'},
    { label: 'Adjustment Type', propertyName: 'brAdjType' },
    { label: 'AE/Sales Contact', propertyName: 'ae' },
    { label: 'Remit Address', propertyName: 'remitAddress' },
    {label:'Requestor',propertyName:'requestor'},
    {label:'Status',propertyName:'statusDesc'},
    {label:'Invoice Number',propertyName:'invoiceNumber'},
    {label:'Statment Number',propertyName:'statementNumber'},
    // {label:'GBS Remarks',properyName:'gbsRemarks'},
    // {label:'GBS Status',propertyName:'gbsStatus'},
    //{label:'MI Remarks',propertyName:'rejectionReason'},
    
       {
      label: 'Action', propertyName: 'icon',
      icons: [
      { toolTip: 'View Statement Details', icon: 'remove_red_eye', callFrom: 'viewDetails' },
      { toolTip: 'Download Files', icon: 'download' , callFrom:'download'},
      { toolTip: 'No SLA breach', tooltipProperty: 'slaInfo',icon: 'warning'}
      ]
    }
  ];

  // ✅ Used for detail table display
  readonly detailTableFieldMapping = [
    { label: 'Adj Req Id', propertyName: 'adjReqId' },
    { label: 'Total Customers', propertyName: 'customerCount' },
    { label: 'Adjustment Type', propertyName: 'brAdjType' },
    { label: 'Description', propertyName: 'descriptionComment' },
    { label: 'Amount', propertyName: 'adjNetAmount' },
    { label: 'Special Instructions', propertyName: 'specialInstructions' },
    { label: 'Requested Date', propertyName: 'adjRequestDate' },
    { label: 'Requester', propertyName: 'requestor' },
    //{ label: 'MI Remarks', propertyName: 'rejectionReason' }
  ];

  readonly mainRequestInfo = [
    { label: 'Adj Req Id', propertyName: 'detailedAdjSubId' },
    { label: 'Requested Date', propertyName: 'adjRequestDate' },
    { label: 'Billing Site', propertyName: 'billingSite' },
    { label: '#MMS', propertyName: 'mms' },
    { label: 'Customer Name', propertyName: 'custName' },
    { label: 'Amount', propertyName: 'totalCorrectCharges' },
    {label:'Check Request',propertyName:'checkRequest'},
    { label: 'Adjustment Method', propertyName: 'adjustmentMethod' },
    { label: 'AE/Sales Contact', propertyName: 'ae' },
    { label: 'Remit Address', propertyName: 'remitAddress' },
    { label: 'MI Status', propertyName: 'status' },
    { label: 'Actioned By (MI)', propertyName: 'approver' },
    { label: 'MI Remarks', propertyName: 'rejectionReason' },
    { label: 'GBS Status', propertyName: 'gbsStatus' },
    { label: 'Actioned By (GBS)', propertyName: 'gbsApprover' },
    { label: 'GBS Remarks', propertyName: 'reason' }
  ];
 invoiceDataSource = new MatTableDataSource<InvoiceDetails>([]);
  checked: boolean = true;
  dataSource = new MatTableDataSource<BillingAdjustmentDetails>([]);
  isAccepted: boolean = true;
  firstFormGroup: FormGroup;
  panels: any[] = [];
  isLoading: boolean = false;

  validateDateRange() {
    const startDate = this.dateForm.get('startDate')?.value;
    const endDate = this.dateForm.get('endDate')?.value;
    this.startDateInvalid = false;
    this.endDateInvalid = false;
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      if (start > end) {
        this.startDateInvalid = true;
        this.endDateInvalid = true;
      }
    }
  }

  constructor(private dialog: MatDialog,
    private modalService: BsModalService,
    private approvalDashBoardService: ApprovalDashBoardService,
    private authService: AuthService,
    private msalService: MsalService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private spinner: SpinnerService,
    private bulkRequestService: BulkRequestService,
  ) {
   }
   

 ngOnInit(): void {
  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  

  this.dateForm = this.fb.group({
    statusFilter: [0]
  });

  this.spinner.showSpinner();
  this.onSubmit(1, 10); // Call with default values on load
}

 

// Method removed - using onSubmit instead



  openAcceptOrRejectDialog(e) {
    this.selectedData = e.details;
     if (e.callFrom === 'download') {
      if(e.details.isFileUploaded)
      {
        this.spinner.showSpinner();
        this.approvalDashBoardService.DownloadUploadedFiles(e.details.adjReqId)
          .subscribe({
            next: data => {
              const filename = `AdjustmentRequest_${e.details.adjReqId}.zip`;  
              const blob = new Blob([data], { type: 'application/zip' });
              saveAs(blob, filename);
              this.spinner.hideSpinner();
              this.toastr.success('File Downloaded Successfully', 'Success');
            },
            error: () => {
              this.spinner.hideSpinner();
              this.toastr.error('Error downloading file', 'Error');
            }
          });
      }
else{
        this.toastr.warning('No Files Uploaded', 'warning');  
      }
    }
else if (e.callFrom === 'viewDetails') {
  this.spinner.showSpinner(); // <-- show spinner immediately
  this.isDetailView = true;

  // Load data
  this.loadDetailsByAdjReqId(e.details.detailedAdjSubId)
    this.spinner.hideSpinner(); // <-- hide after loading is complete
    // Now open modal
    this.detailsModalRef = this.modalService.show(this.detailsTemplate, {
      backdrop: true,
      class: 'modal-xl no-fade',
      animated: false
    });
 

}

  }

 loadDetailsByAdjReqId(detailedAdjSubId: string): void{
  this.spinner.showSpinner();

const selectedRow = this.dataSource.data.find(x => x.detailedAdjSubId === detailedAdjSubId);
  if (selectedRow) {
    this.detailData = [selectedRow]; // Wrap in array for table binding
    this.invoiceDataSource.data = this.detailData;
  } else {
    this.detailData = [];
    this.invoiceDataSource.data = [];
  }
  this.spinner.hideSpinner();
}

closeDetailsPopup() {
  if (this.detailsModalRef) {
    this.detailsModalRef.hide();
  }
  this.isDetailView = false;
}

onSubmit(pageIndex: number = 1, pageSize: number = 10, filters: FilterDto[] = [], isRefresh: boolean = false): void {
  
  this.spinner.showSpinner();
  
  if (isRefresh) {
    pageIndex = 1;
    pageSize = 10;
    this.pageSize = 10;
    this.currentAppliedFilters = []; 
    this.dateForm.patchValue({ statusFilter: 0 });
    filters = []; 
  }
  
  const isFilterChange = filters.length > 0;
  
  if (isFilterChange) {
    this.currentAppliedFilters = [...filters];
    pageIndex = 1; 
  } else if (this.currentAppliedFilters.length > 0) {
    filters = [...this.currentAppliedFilters];
  } else {
    console.log('📄 Simple pagination change - no filters');
  }

  this.pageSize = pageSize;
  const filtersToProcess = filters;
  
  const statusFilterFromMenu = filtersToProcess.find(f => f.column === 'statusName' || f.column === 'statusDesc');
  
  let status: number[];
  if (statusFilterFromMenu) {
    const statusValues = statusFilterFromMenu.value.split(',').map(v => parseInt(v.trim()));
    status = statusValues;
  } else {
    const statusFilter = this.dateForm.get('statusFilter')?.value ?? 0;
    status = statusFilter == 0
      ? [1,3,4,5,6,7,8,9,10,11,13,14]
      : [statusFilter];
  }

  this.filters = filtersToProcess.map(f => {
    if (f.column === 'statusName' || f.column === 'statusDesc') {
      return null;
    }
    else if (f.column === 'custName') {
      return {
        column: 'customerName',
        operator: f.operator || 'contains',
        value: f.value?.toString() || ''
      };
    }
    // Map mms filter
    else if (f.column === 'mms') {
      return {
        column: 'mms',
        operator: f.operator || 'contains',
        value: f.value?.toString() || ''
      };
    }
    return {
      column: f.column,
      operator: f.operator || 'contains',
      value: f.value?.toString() || ''
    };
  }).filter(f => f !== null);

  // Build payload - always use server-side pagination
  // C# backend expects PascalCase property names for proper JSON binding
  const payload = {
    reportType: 1,
    statusId: status,
    PageNumber: pageIndex,    // PascalCase for C# binding
    PageSize: pageSize,       // PascalCase for C# binding
    filters: this.filters
  };
  



  const notYetStatuses = [1,2,3,4,5,14,15];
  
  this.bulkRequestService.getBulkReportByDateRange(payload).subscribe({
    next: (response) => {
      

      const data = Array.isArray(response) ? response : (response.data || response.billingAdjustmentDetails || response);
      const totalFromBackend = response.totalCount || response.TotalCount || data.length;
      
      this.dataSource.data = data;
      
      this.totalCount = totalFromBackend;
      this.pageSize = pageSize;
        
      this.dataSource.data.forEach((x) => {
        x.adjRequestDate = formatDate(x.adjRequestDate, 'MM/dd/yyyy', 'en-US');
        x.statusDesc = BillingAdjustmentStatusEnumDisplay[x.statusId];
        x.slaInfo = x.miApproval.flag ? `${x.miApproval.days} days past SLA` : x.gbsApproval.flag ? `${x.gbsApproval.days} days past SLA` : '';
        x.gbsStatus = x.isGBSNMF
          ? BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.GBSNeedMoreInformation]
          : notYetStatuses.includes(x.statusId) ? '--' : BillingAdjustmentStatusEnumDisplay[x.statusId];
        
        if ((x.gbsStatus === 'GBS Need More Information' && x.statusId !== BillingAdjustmentStatusEnum.Submitted) ||
            (x.gbsStatus !== '--' && x.gbsStatus !== 'GBS Need More Information')) {
          x.status = BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.MIApproved];
        } else {
          if (x.statusId == 1) {
            x.status = '--'
          } else {
            x.status = BillingAdjustmentStatusEnumDisplay[x.statusId];
          }
        }
      });

      this.isLoader = false;
      this.spinner.hideSpinner();
    },
    error: (err) => {
      this.spinner.hideSpinner();
      this.isLoader = false;
      console.error('Error fetching report:', err);
    }
  });
}




  showTooltip = false;
  tooltipSvg = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="200" height="200">
    <text x="10" y="20" class="tooltip-text">$0 - $2,499:  Supervisor</text><br/>
    <text x="10" y="40" class="tooltip-text">$0 - $4,999:  Manager</text><br/>
    <text x="10" y="60" class="tooltip-text">$0 & above:  District Mgr/ Finance Director</text><br/>
    <text x="10" y="80" class="tooltip-text">Any amount of goodwill request: Requires approval from MI Director of Finance</text>
  </svg>
`;
}





